import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import reduceReducers from "reduce-reducers";

import globalReducer from "../ducks/global/reducer";
import categoriesReducer, {
  init_state as categories_state,
  CategoriesState,
} from "../ducks/categories/reducer";
import productsReducer, {
  init_state as products_state,
  ProductsState,
} from "../ducks/products/reducer";
import basketReducer from "./basket/reducer";
import { init_state as basket_state } from "./basket/config";
import { init_state as general_state } from "./general/reducer";
import userReducer from "../ducks/user/reducer";

import defaultStorage from "../configs/storage-config";
import generalReducer from "./general/reducer";
import cartReducer from "./cart/cart-reducers";

import { CartState } from "./cart/cart-types";
import { cart_init_state } from "./cart/cart-constants";

const PERSISTOR_VERSION = 1;

// State
export type State = {
  categories: CategoriesState;
  products: ProductsState;
  cart: CartState;
};

const init_state = {
  categories: categories_state,
  products: products_state,
  basket: basket_state,
  general: general_state,
  cart: cart_init_state,
};

// Persistors

let commonPersistConfig = {
  storage: defaultStorage,
  version: PERSISTOR_VERSION,
  timeout: 0,
};

const categoriesPersistConfig = {
  key: "categories",
  ...commonPersistConfig,
};

const userPersistConfig = {
  key: "user",
  ...commonPersistConfig,
};

const productsPersistConfig = {
  key: "products",
  ...commonPersistConfig,
};

const basketPersistConfig = {
  key: "basket",
  ...commonPersistConfig,
};
const generalPersistConfig = {
  key: "general",
  ...commonPersistConfig,
};

const cartPersistConfig = {
  key: "cart",
  ...commonPersistConfig,
};

// Make it ready

const combinedReducer = combineReducers({
  categories: persistReducer(categoriesPersistConfig, categoriesReducer),
  products: persistReducer(productsPersistConfig, productsReducer),
  basket: persistReducer(basketPersistConfig, basketReducer),
  user: persistReducer(userPersistConfig, userReducer),
  general: persistReducer(generalPersistConfig, generalReducer),
  cart: persistReducer(cartPersistConfig, cartReducer),
});

const rootReducer = reduceReducers(combinedReducer, globalReducer);

export { init_state };
export default rootReducer;
